import { CircularProgress } from '@mui/material'
import React from 'react'

const Loader = () => {
    return (
        <CircularProgress size={20} color="inherit" />
    )
}

export default Loader